var Backbone = require('backbone');

/**
 * global configuration
 */
var Config = Backbone.Model.extend({
  VERSION: 4,

  initialize: function () {},

  // error track
  REPORT_ERROR_URL: '/api/v0/error',
  ERROR_TRACK_ENABLED: false
});

module.exports = Config;



//////////////////
// WEBPACK FOOTER
// ./~/cartodb.js/src/core/config.js
// module id = 1602
// module chunks = 6